import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "inline-flex shrink-0",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("span", _hoisted_1, [
    (_openBlock(), _createBlock("svg", _hoisted_2, [
      _createVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3ZM15.3364 10.8364C15.6879 10.4849 15.6879 9.91508 15.3364 9.5636C14.9849 9.21213 14.4151 9.21213 14.0636 9.5636L11.1 12.5272L9.9364 11.3636C9.58492 11.0121 9.01508 11.0121 8.6636 11.3636C8.31213 11.7151 8.31213 12.2849 8.6636 12.6364L10.4636 14.4364C10.8151 14.7879 11.3849 14.7879 11.7364 14.4364L15.3364 10.8364Z",
        fill: _ctx.printed ? '#36B37E' : '#A7A8AA'
      }, null, 8, ["fill"])
    ]))
  ]))
}